import { t } from '@lingui/macro'
import { WarehouseAsNested } from './Warehouse'
import { WmsAsNested } from './Wms'
import { OrganisationAsNested } from '@typings/entities/Organisation'
import { ProductApiRead } from '@typings/entities/Product'
import { FlagAppearanceType } from '@constants/FlagAppearance'

export const InternalStockChangeTypeTrans = {
  in: () => t({ id: 'stockChangeType.In', message: `In` }),
  out: () => t({ id: 'stockChangeType.Out', message: `Out` }),
}

export const TypeToColor: { [value: string]: FlagAppearanceType } = {
  in: 'purpleSubtle',
  out: 'yellowSubtle',
}

export const InternalStockChangeStatusTrans = {
  new: () => t({ id: 'stockChangeStatus.New', message: `New` }),
  waiting_for_goods: () => t({ id: 'stockChangeStatus.WaitingForGoods', message: `Waiting for goods` }),
  ready: () => t({ id: 'stockChangeStatus.Ready', message: `Ready` }),
  processed: () => t({ id: 'stockChangeStatus.Processed', message: `Processed` }),
  failed: () => t({ id: 'stockChangeStatus.Failed', message: `Failed` }),
  canceled: () => t({ id: 'stockChangeStatus.Canceled', message: `Canceled` }),
}

export const StatusToAppearance: { [value: string]: FlagAppearanceType } = {
  new: 'tealSubtle',
  waiting_for_goods: 'orangeSubtle',
  ready: 'blueSubtle',
  processed: 'greenSubtle',
  failed: 'redBold',
  canceled: 'redSubtle',
}

type InternalStockChangeBare = {
  id: string
  name: string
  receivedAt?: string
  createdAt?: string
  countOfItems: number
  countOfSku: number
  sumOfQuantity: number
  type?: keyof typeof InternalStockChangeTypeTrans
  status: keyof typeof InternalStockChangeStatusTrans
}

export type InternalStockChangeNested = InternalStockChangeBare & {
  wms: WmsAsNested
  warehouse: WarehouseAsNested
  organisation: OrganisationAsNested
}

export type InternalStockChangeApiItem = {
  id: string
  position?: number
  stockChange: string
  ref1?: string
  ref2?: string
  ref3?: string
  lot?: string
  assignedLot?: string
  lifo?: boolean
  expedited?: number
  quantity: number
  booked?: number
  missing?: number
  product: string
}

export type InternalStockChangeApi = InternalStockChangeBare & {
  wms: string
  warehouse: string
  organisation: string
  movements?: string[]
  items?: InternalStockChangeApiItem[]
}

export type InternalStockChangeDetailItem = Omit<InternalStockChangeApiItem, 'product'> & {
  product: ProductApiRead
  availableStock: number | '?' | null
}

export type InternalStockChangeDetail = Omit<InternalStockChangeApi, 'items' | 'createdAt' | 'receivedAt'> & {
  receivedAt?: Date
  createdAt?: Date
  items: InternalStockChangeDetailItem[]
}
